import React, { createContext, useContext, useState } from "react";
import BookConsultationModal from "./BookConsultationModal";
import RequestCallbackModal from "./RequestCallbackModal";
import DownloadChecklistModal from "./DownloadChecklistModal";
import ComplianceDetailModal from "./ComplianceDetailModal";
import IndustryDetailModal from "./IndustryDetailModal";

const ModalContext = createContext(null);

export const ModalProvider = ({ children }) => {
  const [book, setBook] = useState(false);
  const [callback, setCallback] = useState(false);
  const [checklist, setChecklist] = useState(false);
  const [compliance, setCompliance] = useState(null);
  const [industry, setIndustry] = useState(null);

  const value = {
    openBookConsultation: () => setBook(true),
    openRequestCallback: () => setCallback(true),
    openDownloadChecklist: () => setChecklist(true),
    openComplianceDetail: (item) => setCompliance(item),
    openIndustryDetail: (item) => setIndustry(item),
  };

  return (
    <ModalContext.Provider value={value}>
      {children}
      <BookConsultationModal open={book} onOpenChange={setBook} />
      <RequestCallbackModal open={callback} onOpenChange={setCallback} />
      <DownloadChecklistModal open={checklist} onOpenChange={setChecklist} />
      <ComplianceDetailModal item={compliance} onOpenChange={(v) => !v && setCompliance(null)} />
      <IndustryDetailModal industry={industry} onOpenChange={(v) => !v && setIndustry(null)} />
    </ModalContext.Provider>
  );
};

export const useModals = () => {
  const ctx = useContext(ModalContext);
  if (!ctx) throw new Error("useModals must be used within ModalProvider");
  return ctx;
};
